import axios from '../../helpers/axios-setup';
import { NoteTypes } from '../../components/partials/notes/types';

export const getNotesByAppId = (appId: number, type = NoteTypes.APPLICATION) => axios.get(`/notes/${type}/${appId}`);
